import React from 'react';
import antImg from '../../../asset/img/main_taxresult_ant_img.svg';

import FullButton from '../../../components/common/FullButton';
import { useTranslation } from 'react-i18next';
import Badge from '../../../components/common/Badge';
import Typography from '../../../components/common/Typography';

//모의계산
const Tab1Content = ({
  badge = '',
  amount = '',
  resultData,
  buttonList = [],
  handleButtonClick,
  title = '',
  activeTab,
  imgSrc = antImg,
  alt = '',
}) => {
  const { t } = useTranslation('resultQuery');
  return (
    <div className="tabContent">
      {/* 예상입력결과 */}
      <div className="taxResultBox">
        <div className="displayFlexColumn" style={{ gap: '2px' }}>
          <Typography variant="body2Bold">{title}</Typography>
          <div className="displayFlex" style={{ gap: '8px' }}>
            {badge && <Badge color="custom">{badge}</Badge>}
            <Typography variant="body2Medium">{amount}</Typography> {/* 환급 금액 */}
          </div>
        </div>
        <img src={imgSrc} alt={alt} />
      </div>

      {/* 소득공제신고서~~~ 주택 등등 버튼들 */}
      {buttonList.map((item, index) => (
        <FullButton
          icon="arrow"
          title={item.label}
          key={index}
          onClick={() => handleButtonClick(item)}
          disabled={!item.view || (activeTab != 1 && resultData.htmViewMagam != '1')}
        />
      ))}
    </div>
  );
};

export default Tab1Content;
